// extracted by mini-css-extract-plugin
export default {"progressContainer":"ProgressBand_progressContainer__Abeyx","progressBar":"ProgressBand_progressBar__jkAOV"};